import _implicitStylesheets from "./pagination.css";
import _implicitScopedStylesheets from "./pagination.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="axwp-pagination__current${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<a${"a0:href"}${"a0:aria-label"}${3}>${"t1"}</a>`;
const stc0 = {
  classMap: {
    "axwp-pagination": true
  },
  key: 0
};
const stc1 = {
  "axwp-pagination__page-numbers": true
};
const stc2 = {
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", stc0, [api_element("nav", {
    classMap: stc1,
    attrs: {
      "role": "navigation",
      "aria-label": $cmp.labels.paginationAriaLabel
    },
    key: 1
  }, [api_element("ul", stc2, api_iterator($cmp.pages, function (page) {
    return api_element("li", {
      key: api_key(3, page.url)
    }, [page.isCurrent ? api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text(page.index))]) : null, !page.isCurrent ? api_static_fragment($fragment2, 7, [api_static_part(0, {
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.handlePageClick))
      },
      attrs: {
        "href": page.url,
        "aria-label": page.ariaLabel
      }
    }, null), api_static_part(1, null, api_dynamic_text(page.index))]) : null]);
  }))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3e10ga0pemk";
tmpl.legacyStylesheetToken = "undefined-_pagination";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
